/**
 *Created by Heqi on 2018/1/18.
 */

import http from '@/utils/http'
import convert from '@/utils/model-convert'
import { SearchArgument } from '@/models/consumer-month-reports'
import { SearchArgument1 } from '@/models/project-month-consumption'

const URL = '/rest/customer/report/item-consumption-statistics/months'
const URL_PROJECT = '/rest/customer/platform/item-platform-consumptions/months'

export default {
  list ({search}, cb) {
    http.get(URL, {
      params: convert.toJson(search, SearchArgument)
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  listProject ({search}, cb) {
    http.get(URL_PROJECT, {
      params: convert.toJson(search, SearchArgument1)
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  }
}



// WEBPACK FOOTER //
// ./src/api/month-reports.js